import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import SidePanel from "../../components/SidePanel";
import THREEScene from "../../components/Renderer";
// import THREEScene from "../../components/Renderer_New";
import { formatURL } from "../../utils/utils";
// Required Imports for 'Modal popup'
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import CardDeck from "react-bootstrap/CardDeck";
import Card from "react-bootstrap/Card";
import Loading from "../../components/Loading";
import { Form } from "react-bootstrap";

function DesignPage(props) {

  let allowPlace = props.designstep === 2 ? true : false;
  //console.log("DesignPage")
  // console.log("DesignPage :: " + props.designstep)
  return (
    <div className={props.sidebarActive ? "main-container" : "main-container expanded"}>
      <Modal show={props.orientationPopup} onHide={props.closePopup}>
        <Modal.Body>Het is aangeraden om uw scherm te draaien voor een betere ervaring.</Modal.Body>
        <Modal.Footer>
          <Button variant='primary' onClick={props.closePopup}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      {props.designstep === 0 ?
        <div>
          <Container>
            <br />
            <Row>
              <h1>Kamertype Kiezen</h1>
            </Row>
            <Row>
              <p>Kies het type kast dat u wilt ontwerpen.</p>
            </Row>
{/*
          <Grid container spacing={{ md: 1 }} columns={{ md: 12 }}>
              <CardDeck >
              {props.rooms.map(room => {
                const percentage = props.rooms.length > 3 ? (100 / (props.rooms.length / 2) - 5) + "%" : (100 / props.rooms.length - 5) + "%";
                return (
                <Grid item md={2}>
                    <Card key={"room-" + room.room_id} onClick={e => {props.setRoom(room)}} ref={(el) => {if (el) {el.style.setProperty('flex-basis', percentage, 'important');}}}>
                      <Card.Img variant="top" src={formatURL(room.room_thumbnail_path)}/>
                      <br />
                      <Card.Text>{writeSpaces(room.room_description)}</Card.Text>
                      <Button className="btn-room">{ room.room_type === 'mail' ? 'Meer info' : 'Start je ontwerp' }</Button>
                    </Card>
                </Grid>
                )
              })}
              </CardDeck>  
            </Grid>
*/}

            <Row>
            <CardDeck >
              {props.rooms.map(room => {
                const percentage = props.rooms.length > 3 ? (100 / (props.rooms.length / 2) - 5) + "%" : (100 / props.rooms.length - 5) + "%";
                return (
                    <Card key={"room-" + room.room_id} onClick={e => {props.setRoom(room)}} ref={(el) => {if (el) {el.style.setProperty('flex-basis', percentage, 'important');}}}>
                      <Card.Img variant="top" src={formatURL(room.room_thumbnail_path)}/>
                      <br />
                      <Card.Text style={{ textAlign: "center" }}>{room.room_description}</Card.Text>
                      <Button className="btn-room">{ room.room_type === 'mail' ? 'Weldra in de configurator' : 'Start je ontwerp' }</Button>
                    </Card>
                )
              })}
              </CardDeck>  
            </Row>

            </Container>
            
          <Modal show={props.mailPopup} onHide={props.closePopup}>	
            <Modal.Header closeButton id="testing">	
              <Modal.Title>Contact</Modal.Title>	
            </Modal.Header>	
            <Modal.Body>	
              <Form method='POST' encType='multipart/form-data'>
                <Form.Group>
                  <Form.Label>Naam:</Form.Label>
                  <Form.Control type='text' placeholder='Naam' name='mail_name' />
                  <span className={props.formErrorsMail["mail_name"] ? "form-error" : "form-error-hidden"}>{props.formErrorsMail["mail_name"]}</span>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Email:</Form.Label>
                  <Form.Control type='email' placeholder='E-mailadres' name='mail_email' />
                  <span className={props.formErrorsMail["mail_email"] ? "form-error" : "form-error-hidden"}>{props.formErrorsMail["mail_email"]}</span>
                </Form.Group>
				        <Form.Group>
                  <Form.Label>
                    De gekozen kastindeling zit op dit moment nog niet in onze automatische configurator.<br/>
                    Toch kunnen we uw kast voor u uitwerken.<br/>
                    Noteer uw gegevens en geef een korte omschrijving van uw project, wij contacteren u voor de verdere uitwerking van uw project.<br/>
                    Indien u hulp nodig hebt bij het opmeten, komen wij graag terplaatse . Hiervoor vragen wij een onkostenvergoeding van 75 euro.
                  </Form.Label>
                  <Form.Control as="textarea" rows={8} name='mail_question' />
                  <span className={props.formErrorsMail["mail_question"] ? "form-error" : "form-error-hidden"}>{props.formErrorsMail["mail_question"]}</span>
                </Form.Group>
                <Button variant='primary' type='button' onClick={event => props.submitMail(event)}>
                  Doorsturen
                </Button>
                <Form.Group>
                  <span className={props.formErrorsMail["submitError"] ? "form-error" : "form-error-hidden"}>{props.formErrorsMail["submitError"]}</span>
                </Form.Group>
              </Form>
            </Modal.Body>	
          </Modal>

        </div>
        :
        <Container fluid>
          <Row noGutters style={{ paddingTop: ".5rem", paddingLeft: ".5rem" }}>
            <Col id='renderer-container'>
              <div className='scene-container'>
                <THREEScene
                  designstep={props.designstep}
                  room={props.currentRoom}
                  allowPlace={allowPlace}
                  boxDimensions={props.boxDimensions}
                  closetProps={props.closetProps}
                  updateSlots={props.updateSlots}
                  updateLoading={props.updateLoading}
                  updatePrice={props.calculatePrice}
                  updatePageState={props.updatePageState}
                  wallColor={props.wallColor}
                  updateRendererr={props.updateRendererr}
                  khHeight={props.khHeight}
                  moduleClicked={props.moduleClicked}
                  moduleBreedteClicked={props.moduleBreedteClicked}
                />
              </div>
              {props.loading ?
                <div className='module-loading'>
                  <Loading />
                </div>
                : null}

            </Col>
            <Col lg='3'>
              {/* <SidePanelContainer */}
              <SidePanel
                room={props.currentRoom}
                validationSizes={props.validationSizes}
                designstep={props.designstep}
                nextPage={() => { props.updateDesignStep(true) }}
                prevPage={() => { props.updateDesignStep(false) }}
                boxDimensions={props.boxDimensions}
                setBoxDimensions={props.setBoxDimensions}
                closetProps={props.closetProps}
                activeGrip={props.activeGrip}
                activeLade={props.activeLade}
                slots={props.slots}
                modules={props.modules}
                materials={props.materials}
                features={props.features}
                featureTypes={props.featureTypes}
                helps={props.helps}
                setActiveModule={props.setActiveModule}
                setActiveGrip={props.setActiveGrip}
                setActiveLade={props.setActiveLade}
                setInnerMaterial={props.setInnerMaterial}
                setOuterMaterial={props.setOuterMaterial}
                updatePrice={props.calculatePrice}
                generateOrderJSON={props.generateOrderJSON}
                submitOrder={props.submitOrder}
                totalPrice={props.totalPrice}
                formErrors={props.formErrors}
                clearCustomerFormErrors={props.clearCustomerFormErrors}
                wallColor={props.wallColor}
                setWallColor={props.setWallColor}
                khHeight={props.khHeight}
                settings={props.settings}
                testLogin={props.testLogin}
                rendererr={props.rendererr}
                setModuleClicked={props.setModuleClicked}
                setModuleBreedteClicked={props.setModuleBreedteClicked}
              />
            </Col>
          </Row>
        </Container>}
    </div>
  );
}

export default DesignPage;
